import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";

import SidebarToolInfoModal from "../../components/SidebarToolInfoModal";
import {
  SERVICE_ORDER_HELP_TITLE,
  ServiceOrderHelpContent,
} from "./serviceOrderHelpContent";

function ServiceOrderInfoButton({ t, className, title }) {
  const [showHelpModal, setShowHelpModal] = useState(false);
  const helpTitle =
    title || t("Como criar e enviar uma ordem de serviço?");

  return (
    <>
      <button
        type="button"
        className={className || "pending-schedules-info-btn"}
        title={helpTitle}
        aria-label={helpTitle}
        onClick={() => setShowHelpModal(true)}
      >
        <FaInfoCircle />
      </button>
      {showHelpModal && (
        <SidebarToolInfoModal
          title={t(SERVICE_ORDER_HELP_TITLE)}
          onClose={() => setShowHelpModal(false)}
        >
          <ServiceOrderHelpContent />
        </SidebarToolInfoModal>
      )}
    </>
  );
}

export default ServiceOrderInfoButton;
